<template>
  <div class="main-wrapper">
    <p class="necessary-bold">
      <span
        :class="isIP || isUprcomp || isPerson ? 'valid-field' : 'unvalid-field'"
        >➤</span
      >
      Единоличным исполнительным органом является:
    </p>
    <div class="main-checkboxes">
      <label
        ><input
          type="checkbox"
          v-model="isPerson"
          @click="
            isIP = false;
            isUprcomp = false;
            selectedTable = JSON.parse(JSON.stringify(personTable));
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('CEO_IS_PERSON') != -1
          "
        />Физическое лицо</label
      >
      <label
        ><input
          type="checkbox"
          v-model="isUprcomp"
          @click="
            isIP = false;
            isPerson = false;
            selectedTable = JSON.parse(JSON.stringify(uprcompTable));
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('CEO_IS_UPRCOMP') != -1
          "
        />Управляющая компания</label
      >
      <label
        ><input
          type="checkbox"
          v-model="isIP"
          @click="
            isPerson = false;
            isUprcomp = false;
            selectedTable = JSON.parse(JSON.stringify(ipTable));
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('CEO_IS_IP') != -1
          "
        />Индивидуальный предприниматель
      </label>
    </div>
    <div class="main-table" v-if="isIP || isUprcomp || isPerson">
      <p class="necessary-table-not" v-if="!checkMainFiles()">
        Приложите ВСЕ документы.
      </p>
      <p class="min-one-file">
        Вы можете приложить только один файл или архив. Если необходимо
        приложить несколько документов, добавьте документы в архив и прикрепите
        архив.
      </p>
      <table>
        <tr v-for="item in selectedTable" :key="item.id">
          <td class="left-column">
            <p>
              {{ item.CAPTION }}
            </p>
          </td>
          <td width="250px">
            <input
              v-show="item.FILE == null"
              type="file"
              id="main_file"
              ref="main_file"
              accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
              v-on:change="mainFileUpload(item.id)"
              @click="
                item.FILE = null;
                validation();
              "
            />
            <div
              class="file-name-icon"
              v-if="item.FILE != null"
              @click="onClickBan(item.id)"
            >
              <div class="icons">
                <i class="fa fa-trash"></i>
              </div>
              <p class="file-name">{{ item.FILE.name }}</p>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div
      class="server-docs"
      v-if="importantFiles.length > 0 || unimportantFiles.length > 0"
    >
      <p class="necessary-table-not" v-if="!checkImportantFiles()">
        Выделенные документы приложите обязательно.
      </p>
      <p class="min-one-file">
        Вы можете приложить только один файл или архив. Если необходимо
        приложить несколько документов, добавьте документы в архив и прикрепите
        архив.
      </p>
      <table v-if="showFiles">
        <tr v-for="item in importantFiles" :key="item.CAPTION">
          <td class="left-column">
            <p class="necessary-bold">
              {{ item.CAPTION }}
            </p>
          </td>
          <td width="250px">
            <input
              v-show="item.FILE == null"
              type="file"
              id="file"
              ref="file"
              accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
              v-on:change="imFileUpload(item.ID)"
              @click="
                item.FILE = null;
                validation();
              "
            />
            <div
              class="file-name-icon"
              v-if="item.FILE != null"
              @click="onClickBanIm(item.ID)"
            >
              <div class="icons">
                <i class="fa fa-trash"></i>
              </div>
              <p class="file-name">{{ item.FILE.name }}</p>
            </div>
          </td>
        </tr>
        <tr v-for="item in unimportantFiles" :key="item.CAPTION">
          <td class="left-column">
            <p>{{ item.CAPTION }}</p>
          </td>
          <td width="250px">
            <input
              v-show="item.FILE == null"
              type="file"
              id="file"
              ref="un_file"
              accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
              v-on:change="umFileUpload(item.ID)"
              @click="item.FILE = null"
            />
            <div
              class="file-name-icon"
              v-if="item.FILE != null"
              @click="onClickBanUn(item.ID)"
            >
              <div class="icons">
                <i class="fa fa-trash"></i>
              </div>
              <p class="file-name">{{ item.FILE.name }}</p>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainDocs",
  props: {
    pageInfo: {},
    pageName: String,
  },
  data: () => ({
    sendData: {},
    importantFiles: [],
    unimportantFiles: [],
    personTable: [{ id: 0, CAPTION: "Кадровый приказ", FILE: null }],
    uprcompTable: [
      {
        id: 0,
        CAPTION:
          "Договор с управляющей компанией о передаче полномочий единоличного исполнительного органа",
        FILE: null,
      },
      {
        id: 1,
        CAPTION:
          "Устав управляющей компании (действующая редакция и редакция действующая на момент избрания единоличного исполнительного органа)",
        FILE: null,
      },
      {
        id: 2,
        CAPTION:
          "Решение или протокол об избрании единоличного исполнительного органа в управляющей компании",
        FILE: null,
      },
      { id: 3, CAPTION: "Кадровый приказ", FILE: null },
    ],
    ipTable: [
      {
        id: 0,
        CAPTION:
          "Договор с индивидуальным предпринимателем о передаче полномочий",
        FILE: null,
      },
    ],
    selectedTable: [],
    isPerson: false,
    isUprcomp: false,
    showFiles: false,
    isIP: false,
  }),
  methods: {
    onClickBan(id) {
      if (
        this.selectedTable[id].DISABLED == null ||
        !this.selectedTable[id].DISABLED
      ) {
        this.selectedTable[id].FILE = null;
        let input = this.$refs.main_file[id];
        input.type = "text";
        input.type = "file";
      }
    },
    onClickBanIm(id) {
      if (
        this.importantFiles[id].DISABLED == null ||
        !this.importantFiles[id].DISABLED
      ) {
        this.importantFiles[id].FILE = null;
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
        this.validation();
        this.$forceUpdate();
      }
    },
    onClickBanUn(id) {
      if (
        this.unimportantFiles[id].DISABLED == null ||
        !this.unimportantFiles[id].DISABLED
      ) {
        this.unimportantFiles[id].FILE = null;
        let input = this.$refs.un_file[id];
        input.type = "text";
        input.type = "file";
        this.validation();
        this.$forceUpdate();
        this.$emit("updated");
      }
    },
    mainFileUpload(id) {
      if (this.checkFilesHas(this.$refs.main_file[id].files[0])) {
        let input = this.$refs.main_file[id];
        input.type = "text";
        input.type = "file";
      } else this.selectedTable[id].FILE = this.$refs.main_file[id].files[0];
      this.validation();
      this.$emit("updated");
    },
    imFileUpload(id) {
      if (this.checkFilesHas(this.$refs.file[id].files[0])) {
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
      } else this.importantFiles[id].FILE = this.$refs.file[id].files[0];
      this.$forceUpdate();
      this.validation();
      this.$emit("updated");
    },
    umFileUpload(id) {
      if (this.checkFilesHas(this.$refs.un_file[id].files[0])) {
        let input = this.$refs.un_file[id];
        input.type = "text";
        input.type = "file";
      } else this.unimportantFiles[id].FILE = this.$refs.un_file[id].files[0];
      this.$forceUpdate();
      this.$emit("updated");
    },
    validation() {
      var a =
        this.checkMainFiles() &&
        this.checkImportantFiles() &&
        (this.isPerson || this.isUprcomp || this.isIP);
      var msg = "";
      if (!(this.isPerson || this.isUprcomp || this.isIP))
        msg +=
          'Заполните поле "Единоличным исполнительным органом является";<br>';
      if (!this.checkMainFiles())
        msg += "Приложите ВСЕ первичные документы;<br>";
      if (!this.checkImportantFiles())
        msg += "Приложите ВСЕ выделенные документы;<br>";
      this.$emit("enableButtons", true, msg);
      if (a) {
        this.sendData.FILES = this.createFileList();
        this.sendData.CEO_IS_PERSON = this.isPerson;
        this.sendData.CEO_IS_UPRCOMP = this.isUprcomp;
        this.sendData.CEO_IS_IP = this.isIP;
        this.$emit("changePageSendData", this.sendData, true);
      }
    },
    checkFilesHas(file) {
      let a = false;
      if (file != null) {
        this.importantFiles.forEach((item) => {
          if (item.FILE != null) {
            a = a || item.FILE.name == file.name;
          }
        });
        if (!a)
          this.unimportantFiles.forEach((item) => {
            if (item.FILE != null) {
              a = a || item.FILE.name == file.name;
            }
          });
        if (!a && (this.isIP || this.isPerson || this.isUprcomp))
          this.selectedTable.forEach((item) => {
            if (item.FILE != null) {
              a = a || item.FILE.name == file.name;
            }
          });
      }
      if (a) this.$alert("Файл " + file.name + " уже загружен");
      else if (file.size > 31457280) {
        this.$alert(
          "Размер файла " + file.name + " превышает допустимый размер (30 МБ)"
        );
        a = true;
      }
      return a;
    },
    checkMainFiles() {
      var a = true;
      this.selectedTable.forEach((item) => {
        if (item.FILE == null) a = false;
      });
      return a;
    },
    checkImportantFiles() {
      var a = true;
      this.importantFiles.forEach((item) => {
        if (item.FILE == null) a = false;
      });
      return a;
    },
    createFileList() {
      var files = [];
      var userFiles = [
        ...this.selectedTable,
        ...this.importantFiles,
        ...this.unimportantFiles,
      ];
      userFiles.forEach((item) => {
        var a = true;
        if (this.pageInfo.FILES != null) {
          this.pageInfo.FILES.forEach((file) => {
            if (
              file.DESCRIPTION == item.CAPTION &&
              item.FILE != null &&
              item.FILE.name == file.DS_FILE_NAME
            ) {
              a = false;
            }
          });
        }
        if (a && item.FILE != null) {
          files.push(item);
        }
      });
      if (this.pageInfo.FILES != null)
        this.pageInfo.FILES.forEach((file) => {
          var a = true;
          userFiles.forEach((item) => {
            if (item.CAPTION == file.DESCRIPTION && item.FILE != null)
              a = false;
          });
          if (a) {
            files.push({ FILE: null, CAPTION: file.DESCRIPTION });
          }
        });
      return files;
    },
  },
  created() {
    try {
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
      if (this.pageInfo.FILE_DESCRIPTIONS != null) {
        this.pageInfo.FILE_DESCRIPTIONS.slice().forEach((element) => {
          element.FILE = null;
          if (element.MANDATORY) {
            element.ID = this.importantFiles.length;
            this.importantFiles.push(element);
          } else {
            element.ID = this.unimportantFiles.length;
            this.unimportantFiles.push(element);
          }
        });
      }
      if (this.pageInfo.CEO_IS_PERSON != null && this.pageInfo.CEO_IS_PERSON) {
        this.isPerson = true;
        this.isIP = false;
        this.isUprcomp = false;
        this.selectedTable = JSON.parse(JSON.stringify(this.personTable));
      } else if (
        this.pageInfo.CEO_IS_UPRCOMP != null &&
        this.pageInfo.CEO_IS_UPRCOMP
      ) {
        this.isPerson = false;
        this.isIP = false;
        this.isUprcomp = true;
        this.selectedTable = JSON.parse(JSON.stringify(this.uprcompTable));
      } else if (this.pageInfo.CEO_IS_IP != null && this.pageInfo.CEO_IS_IP) {
        this.isPerson = false;
        this.isIP = true;
        this.isUprcomp = false;
        this.selectedTable = JSON.parse(JSON.stringify(this.ipTable));
      }
      if (this.pageInfo.FILES != null) {
        this.pageInfo.FILES.forEach((item) => {
          this.importantFiles.forEach((file) => {
            if (file.CAPTION == item.DESCRIPTION) {
              if (item.DS_FILE_NAME != null) {
                file.FILE = { name: item.DS_FILE_NAME };
              }
              file.DISABLED = item.DISABLED != null && item.DISABLED;
            }
          });
          this.unimportantFiles.forEach((file) => {
            if (file.CAPTION == item.DESCRIPTION) {
              if (item.DS_FILE_NAME != null) {
                file.FILE = { name: item.DS_FILE_NAME };
              }
              file.DISABLED = item.DISABLED != null && item.DISABLED;
            }
          });
          this.selectedTable.forEach((file) => {
            if (file.CAPTION == item.DESCRIPTION) {
              if (item.DS_FILE_NAME != null) {
                file.FILE = { name: item.DS_FILE_NAME };
              }
              file.DISABLED = item.DISABLED != null && item.DISABLED;
            }
          });
        });
      }
      this.showFiles = true;
      this.validation();
    } catch (error) {
      console.log(error);
    }
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.left-column {
  padding-right: 10px;
}
tr {
  border-bottom: 1px solid #cccccc;
  border-top: 1px solid #cccccc;
}
td {
  padding: 3px 3px;
}
table {
  border-collapse: collapse;
  width: 100%;
}
.necessary {
  color: red;
}
label {
  margin-bottom: 5px;
}
.main-checkboxes {
  display: flex;
  flex-direction: column;
}
.min-one-file {
  text-align: center;
  font-size: 12px;
}
.main-wrapper {
  text-align: justify;
}
.icons {
  position: absolute;
  padding-left: 255px;
  padding-top: 5px;
  background-color: white;
  border: none;
  color: red;
  font-size: 17px;
}
</style>
